import { render } from "./UserReports.vue?vue&type=template&id=975fc966&scoped=true"
import script from "./UserReports.vue?vue&type=script&lang=js"
export * from "./UserReports.vue?vue&type=script&lang=js"

import "./UserReports.vue?vue&type=style&index=0&id=975fc966&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975fc966"]])

export default __exports__